import React from 'react';
import IntakeCaptureChecklist from '../shared/IntakeCaptureChecklist';

function EscalatedIntakeDetailCard({ intakeSession, onClose, onResolve, resolving = false, theme = 'light' }) {
    const dark = theme === 'dark';
    const cardCls = dark ? 'bg-gray-800 border-gray-600 text-gray-100' : 'bg-white border-gray-200 text-gray-800';
    const labelCls = dark ? 'text-gray-400' : 'text-gray-500';
    const dividerCls = dark ? 'border-gray-700' : 'border-gray-100';

    return (
        <div className={`ia-dispatch rounded-xl border p-5 mt-1 ${cardCls}`}>
            <div className="flex items-start justify-between mb-4">
                <div>
                    <h3 className="text-base font-semibold">Escalated Intake Detail</h3>
                    <p className={`text-xs mt-0.5 ${labelCls}`}>Channel: {intakeSession.channel || '—'}</p>
                </div>
                <button onClick={onClose} className={`text-lg leading-none p-1 rounded hover:bg-gray-200/40 ${labelCls}`} aria-label="Close detail">✕</button>
            </div>

            <section className={`border-t pt-4 ${dividerCls}`}>
                <h4 className="text-xs font-semibold uppercase tracking-wide mb-2">Capture Checklist</h4>
                <IntakeCaptureChecklist checklist={intakeSession.capture_checklist} theme={theme} />
            </section>

            <section className={`mt-4 pt-4 border-t ${dividerCls}`}>
                <h4 className="text-xs font-semibold uppercase tracking-wide mb-2">Conversation Log</h4>
                <pre className={`text-xs whitespace-pre-wrap break-words ${labelCls}`}>{JSON.stringify(intakeSession.conversation_log || [], null, 2)}</pre>
            </section>

            <section className={`mt-4 pt-4 border-t ${dividerCls}`}>
                <h4 className="text-xs font-semibold uppercase tracking-wide mb-2">Raw Message Log</h4>
                <pre className={`text-xs whitespace-pre-wrap break-words ${labelCls}`}>{JSON.stringify(intakeSession.raw_message_log || [], null, 2)}</pre>
            </section>

            <div className={`mt-4 pt-4 border-t flex justify-end gap-2 ${dividerCls}`}>
                <button onClick={onClose} className={`px-3 py-1.5 text-xs rounded-lg border ${dark ? 'border-gray-600 text-gray-300 hover:bg-gray-700' : 'border-gray-300 text-gray-700 hover:bg-gray-50'}`}>Close</button>
                {onResolve && <button onClick={() => onResolve(intakeSession.id)} disabled={resolving} className="px-3 py-1.5 text-xs font-medium rounded-lg bg-[var(--btn-fill)] text-[var(--btn-ink)] hover:bg-[var(--btn-fill-hover)] disabled:opacity-50">{resolving ? 'Resolving…' : 'Mark Resolved'}</button>}
            </div>
        </div>
    );
}

export default EscalatedIntakeDetailCard;
